export default "__VITE_ASSET__6NAGU4yxZv4gqo8aTZNSKg__"